import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

export const ChatContext = createContext({
  ssoId: '',
  profile: {},
  responsiveness: {},
  addInputErrorIds: noop,
  removeInputErrorIds: noop,
  clearInputErrors: noop,
  inputErrors: [],
  accessToken: '',
  displayResponsiveness: false,
  sendMessage: null,
  bookingId: '',
  bookingState: '',
  viewAs: '',
  savedMessageText: '',
  setSavedMessageText: noop,
  savedAttachments: [],
  setSavedAttachments: noop
});

export const ChatContextProvider = ({ children, ...rest }) => {
  return <ChatContext.Provider value={{ ...rest }}>
    {children}
  </ChatContext.Provider>;
};

ChatContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  ssoId: PropTypes.string,
  profile: PropTypes.object,
  inputErrors: PropTypes.array,
  removeInputErrorIds: PropTypes.func,
  addInputErrorIds: PropTypes.func,
  clearInputErrors: PropTypes.func,
  displayResponsiveness: PropTypes.bool,
  savedMessageText: PropTypes.string,
  setSavedMessageText: PropTypes.func,
  savedAttachments: PropTypes.array,
  setSavedAttachments: PropTypes.func,
  sendMessage: PropTypes.func,
  bookingId: PropTypes.string,
  bookingState: PropTypes.string,
  viewAs: PropTypes.string,
  generateMessageMetadata: PropTypes.func,
  accessToken: PropTypes.string,
  responsiveness: PropTypes.object,
  client: PropTypes.object
};
